import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../shared/http-utils';
import { URL_BASE } from '../../../core/constants';
import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ForcedCheckinResult } from './forced-checkin-result';
import { PlantForcedCheckin } from './plant-forced-checkin';
import { ForcedCheckinDateRange } from '../forced-checkin.component';
import { Observable } from 'rxjs';

@Injectable()
export class ForcedCheckinSearchService {

  constructor(private http: HttpClient) {
  }

  public searchByCriteria(
    regionId: string,
    carrierId: string,
    search: string,
    range: ForcedCheckinDateRange
  ): Observable<ForcedCheckinResult[]> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/forced-checkin`;
    return this.http.get(url, {
      headers: headers,
      params: this.prepareQueryParams(range, carrierId, regionId, search)
    })
      .pipe(map(result => ForcedCheckinResult.entitiesFromDto(result)));
  }

  public getPlantForcedCheckins(
    glid: string,
    range: ForcedCheckinDateRange,
    carrierId: string
  ): Observable<PlantForcedCheckin[]> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/forced-checkin/${glid}`;
    return this.http.get(url, {
      headers: headers,
      params: this.prepareQueryParams(range,  carrierId)
    })
      .pipe(map(result => PlantForcedCheckin.entitiesFromDto(result)));
  }

  private prepareQueryParams(range: ForcedCheckinDateRange,
                             carrierId: string,
                             regionId: string = null,
                             search: string = null,
  ): HttpParams {

    let params = new HttpParams()
    if (null != regionId) {
      params = params.append('regionId', regionId);
    }
    if (null != carrierId) {
      params = params.append('carrierId', carrierId);
    }
    if (null != search) {
      params = params.append('locationGlidOrName', search);
    }
    if (null != range) {
      params = params.append('range', range);
    }
    return params;
  }

}
